import { clsx } from 'clsx';
import { Avatar } from '@material-ui/core';
import { AccountCircleOutlined, RestaurantOutlined } from '@material-ui/icons';

import makeClasses from './ItemAvatar.style';

import type { ItemAvatarProps } from './itemAvatar.model';

export function ItemAvatar(props: ItemAvatarProps) {
  const { classes, children, iconVariant = 'restaurant', ...restProps } = props;

  const showRestIcon = !Boolean(children) && iconVariant === 'restaurant';
  const showAccountIcon = !Boolean(children) && iconVariant === 'account';

  const _classes = makeClasses();

  return (
    <Avatar
      variant='rounded'
      classes={{
        ...classes,
        rounded: clsx(_classes.avatar, classes?.rounded),
      }}
      {...restProps}
    >
      {children}
      {showRestIcon && <RestaurantOutlined />}
      {showAccountIcon && <AccountCircleOutlined />}
    </Avatar>
  );
}
